import axios from 'axios'
import store from '@/store'
import global from '@/api/global'
import {
  encryption
} from '@/utils/util'
import {
  Message
} from 'element-ui'

axios.defaults.timeout = 10000000

let Authorization1 = encryption({
  data: {
    Basic: global.headerBasic
  },
  type: 'Base64',
  param: ['Basic']
})

function getToken () {
  // 判断token的有效性，当token有效则返回token，token失效并过期返回 null，token即将过期返回 refresh_token
  let token = store.getUser().access_token
  let tokens = store.getUser()
  if (tokens && token) {
    let create_time = store.getUser().create_time
    let expires_in = store.getUser().expires_in
    // 1/3时就要去换取token
    let expires_in3 = expires_in * 0.2
    let starttime = create_time + expires_in3
    // 减去10秒
    let endtime = create_time + (expires_in - 10000)
    // console.log("换取token的有效时间：" + dateFormat(new Date(starttime)) + "======" + dateFormat(new Date(endtime)));
    // console.log(token);
    let currTime = new Date().getTime()
    // console.log("当前时间：" + dateFormat(new Date(currTime)));
    // 在这个范围都可以换取token
    if (currTime > starttime && currTime < endtime) {
      return 'refresh_token'
    }
  }
  return token
}
/* 是否有请求正在刷新token */
window.isRefreshing = false
/* 被挂起的请求数组 */
let refreshSubscribers = []
/* push所有请求到数组中 */
function subscribeTokenRefresh (cb) {
  refreshSubscribers.push(cb)
}

/* 刷新请求（refreshSubscribers数组中的请求得到新的token之后会自执行，用新的token去请求数据） */
function onRrefreshed (token) {
  refreshSubscribers.map(cb => cb(token))
}

// 请求拦截器
axios.interceptors.request.use(
  config => {
    // let tokenUrl = global.commonName + '/oauth/token'
    let tokenUrlV2 = global.commonNameV2 + '/oauth/token'
    // let isCheckSMS = global.commonName + '/user/isCheckSMS'
    let isCheckSMSV2 = global.commonNameV2 + '/user/isCheckSMS'
    // let sendSMS = global.commonName + '/user/sendSMS'
    let sendSMSV2 = global.commonNameV2 + '/user/sendSMS'
    // let checkSMS = global.commonName + '/user/checkSMS'
    let checkSMSV2 = global.commonNameV2 + '/user/checkSMS'
    // let registerSend = global.crm + '/register/smsCheck'
    // let checkUser = global.crm + '/register/checkUser'
    // let registerUser = global.crm + '/register/registerUser'
    // let registerInfo = global.crm + '/registerInfo/add'
    // let CheckCompanyName = global.crm + '/registerInfo/CheckCompanyName'
    let oauthSendSMS = global.commonNameV2 + '/oauth/sendSMS'
    let forgetpasswor = global.commonNameV2 + '/oauth/forgetpasswor'
    if (config.url !== checkSMSV2 && config.url !== sendSMSV2 && config.url !== isCheckSMSV2 &&
      config.url !== tokenUrlV2 && config.url !== forgetpasswor && config.url !== oauthSendSMS) {
      var token = getToken()
      if (token && token !== 'refresh_token') {
        config.headers['Authorization'] = 'Bearer ' + token // 请求接口
        return config
      } else if (token == 'refresh_token') {
        if (!window.isRefreshing) {
          window.isRefreshing = true
          axios({
            headers: {
              Authorization: 'Basic ' + Authorization1.Basic
            },
            method: 'post',
            url: tokenUrlV2,
            params: {
              grant_type: 'refresh_token',
              refresh_token: store.getUser().refresh_token
            }
          })
            .then(res => {
              window.isRefreshing = false
              // config.headers['Authorization'] = 'Bearer ' + res.data.access_token // 换取token
              let token = res.data
              store.setUser(token)
              onRrefreshed('Bearer ' + res.data.access_token)
            })
            .catch(error => {
              console.log(error)
            })
        }

        /* 把请求(token)=>{....}都push到一个数组中 */
        let retry = new Promise((resolve, reject) => {
          /* (token) => {...}这个函数就是回调函数 */
          subscribeTokenRefresh((token) => {
            config.headers.Authorization = token
            /* 将请求挂起 */
            resolve(config)
          })
        })
        return retry
      } else {
        store.delUser()
        localStorage.clear()
        sessionStorage.clear()
        window.location.href = './#/login'
      }
    } else {
      return config
    }
  },
  error => {
    Message({
      message: error,
      type: 'error',
      showClose: true,
      duration: 5 * 1000
    })
    return Promise.reject(error)
  }
)
let flag = true
// 响应拦截器
axios.interceptors.response.use(
  // 如果要获取HTTP信息，如头或状态 return response => response

  /**
   * 通过自定义code确定请求状态 这只是一个例子 您还可以通过HTTP状态代码判断状态
   */
  response => {
    let status = response.status
    let res = response.data
    // 获取所属客户接口前端新增showName和itemNo 只传tenantCode，返回list
    if (response.config.url == '/crm-server3/crm3/sCustomer/list') {
      if (res.data instanceof Array) {
        res.data.forEach(element => {
          element.showName = element.name
          element.itemNo = element.taxpayerNumber
        })
      }
    }
    if (parseInt(res.code) == 0 && status === 200) {
      return res
    }
    if (
      parseInt(res.code) == 40002 ||
      parseInt(res.code) == 40001 ||
      parseInt(res.code) == 40006 ||
      parseInt(res.code) == 40000
    ) {
      store.delUser()
      localStorage.clear()
      sessionStorage.clear()
      window.location.href = './#/login'
    }
    if (res.code) {
      if (status !== 200 || parseInt(res.code) !== 0) {
        return Promise.reject(res)
      }
    }

    return res
  },
  error => {
    // debugger
    // 处理响应错误
    let status = null
    let res = {}
    if (!error.response) {
      return Promise.reject(error)
    }
    if (error.response.status) {
      status = error.response.status
    } else {
      status = 500
    }
    if (error.response.data) {
      res = error.response.data
    } else {
      res.code = 500
      res.msg = '系统错误'
    }
    if (status === 401) {
      store.delUser()
      localStorage.clear()
      sessionStorage.clear()
      window.location.href = './#/login'
      Message({
        message: 401,
        type: 'error',
        showClose: true,
        duration: 5 * 1000
      })
    } else if (status === 428) {
      store.delUser()
      localStorage.clear()
      sessionStorage.clear()
      window.location.href = './#/login'
      Message({
        message: 428,
        type: 'error',
        showClose: true,
        duration: 5 * 1000
      })
    } else if (status === 504) {
      if (flag) {
        Message({
          message: '系统繁忙，请稍后再试',
          type: 'error',
          showClose: true,
          duration: 5 * 1000
        })
        flag = false
      }
    } else {
      if (flag) {
        if (res.code) {
          Message({
            message: res.msg,
            type: 'error',
            showClose: true,
            duration: 5 * 1000
          })
        } else {
          Message({
            message: '系统开小差，请稍候再试。',
            type: 'error',
            showClose: true,
            duration: 5 * 1000
          })
        }
        flag = false
      }
    }
    // 处理响应错误
    return Promise.reject(error)
  }
)

export function post (url, data = {}) {
  return new Promise((resolve, reject) => {
    axios.post(url, data).then(
      response => {
        resolve(response.data)
      },
      err => {
        reject(err)
      }
    )
  })
}

export function post1 (url, data = {}) {
  return new Promise((resolve, reject) => {
    axios.post(url, data).then(
      response => {
        resolve(response)
      },
      err => {
        reject(err)
      }
    )
  })
}

export function get (url, params = {}) {
  return new Promise((resolve, reject) => {
    axios
      .get(url, {
        params: params
      })
      .then(response => {
        resolve(response.data)
      })
      .catch(err => {
        reject(err)
      })
  })
}

// export function delete (url, data = {}) {
//   return new Promise((resolve, reject) => {
//     axios.delete(url, data)
//       .then(response => {
//         resolve(response.data)
//       }, err => {
//         reject(err)
//       })
//   })
// }
